import { createBrowserRouter } from 'react-router-dom';
import Layout from './pages/Layout';
import Home from './pages/home/Home';
import Single from './pages/accommodation/Single';
import {
  DOUBLE_ROOM,
  SINGLE_ROOM,
  SUPERIOR_DOUBLE_ROOM,
} from './utils/constants';
import Double from './pages/accommodation/Double';
import SuperiorDouble from './pages/accommodation/SuperiorDouble';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: SINGLE_ROOM,
        element: <Single />,
      },
      {
        path: DOUBLE_ROOM,
        element: <Double />,
      },
      {
        path: SUPERIOR_DOUBLE_ROOM,
        element: <SuperiorDouble />,
      },
    ],
  },
]);

export default router;
